import {dataHooks} from '@wix/data-hooks'

export const reservationDetailsSectionDataHooks = dataHooks<{
  changeReservation: {}
}>('reservation-details-section')
